import { afterNextRender, Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ApiService } from '../../services/api.service';
import { IVisitorCounter, VISITOR_COUNTER_API_RESPONSE } from '../../models/VisitorCounter.Model';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, TranslatePipe],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {

apiService = inject(ApiService);
visitorCounter = signal<IVisitorCounter>(<IVisitorCounter>{});

constructor(){
  afterNextRender(()=>{
    this.getCount();  })
}
 getCount() {
    this.apiService.maskLoader(true);
    this.apiService.requestGet('appkey/site/counter').subscribe({
      next: (response: VISITOR_COUNTER_API_RESPONSE | any) => {
        this.visitorCounter.set(response.dataobject) ;     
        this.apiService.maskLoader(false);
      },
      error: (error) => { 
        this.apiService.maskLoader(false);
      }
    })
  }
}
